import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-bill-analyst',
  templateUrl: './bill-analyst.component.html',
  styleUrls: ['./bill-analyst.component.css']
})

export class BillAnalystComponent implements OnInit {
  bans: any;
  newUrl: any;
  closeResult = '';
  customerIdSearch: String = "";
  isSubmitButtonDisabled: boolean = true;
  errorMessage: string = "An error occurred while processing your request. Please try again later."
  selectedCustomer: string | null = null;
  registrationMessage: string = " ";
  isLoading: boolean = false;

  customerIds: String[] = environment.billingProps.customerIds;
  lumenGlobysID: String = environment.billingProps.lumenGlobysID;
  
  constructor(
    private router: Router, 
    private modalService: NgbModal, 
    private http: HttpClient
  ) { }

  ngOnInit() {
    if (this.customerIds && !this.customerIds.includes(environment.customerID)) {
      if (environment.customerID) {
        this.customerIds.push(environment.customerID);
      }
    }
    this.bans = []
  }

  get currentRoute() {
    return this.router.url
  }

  get getCustomerIds() {
    let searchArray = [];
    if (this.customerIdSearch) {
      for (let id of this.customerIds) {
        if (id.toLowerCase().includes(this.customerIdSearch.toLowerCase())) {
          searchArray.push(id);
        }
      }
      return searchArray;
    }
    else {
      return this.customerIds;
    }
  }

  open(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result: any) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason: any) => {
        this.closeResult =
          `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  onRadioChange(event: Event) {
    const input = event.target as HTMLInputElement;
    console.log("Radio button changed:", input.value);
    this.selectedCustomer = input.checked ? input.value : null;
    this.isSubmitButtonDisabled = this.selectedCustomer === null ? true : false;
    console.log("Selected customer ID:", this.selectedCustomer);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  launchBillAnalyst(content: any) {
    this.isLoading = true;
    const url = environment.serverURL + environment.pgURI + "salesforce/lumen-account";
    const data = {
      account: this.selectedCustomer ? [this.selectedCustomer] : [],
      extended: false
    };
    var keyname = JSON.parse(localStorage.getItem("msal.account.keys") || '[]');
    var clientInfo = JSON.parse(localStorage.getItem(keyname[0]) || '');
    let email = clientInfo.username;
    let logTraceJSON: any = { 'eventSource': 'billAnalystPostLumenAccount', 'payload': data, 'customerId': this.selectedCustomer, 'email': email };
    const headers = new HttpHeaders({
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    this.http.post(url, data, {headers}).subscribe(
      (res: any) => {
        if (res.length === 0) {
          this.handleError(content, "Unable to process your request, Please try again later.");
          return;
        }
        const customer = res[0];[]
        let username = '';
        if (this.lumenGlobysID === "Brightspeed") {
          if (customer.Lumen_Account__c === "null" && customer.Lumen_Customer_EID__c === "null") {
            username = email + ":" + customer.EW_Account_Number__c;
          } else if (customer.Lumen_Account__c !== "null" && customer.Lumen_Customer_EID__c === "null") {
            username = email + ":" + customer.Lumen_Account__c;
          } else if (customer.Lumen_Account__c !== "null" && customer.Lumen_Customer_EID__c !== "null") {
            username = customer.Lumen_Customer_EID__c + ":" + email + ":" + customer.Lumen_Account__c;
          }
        } else {
          if (customer.Lumen_Account__c === "null" && customer.Lumen_Customer_EID__c === "null") {
            username = this.lumenGlobysID + ":" + customer.EW_Account_Number__c;
          } else if (customer.Lumen_Account__c !== "null" && customer.Lumen_Customer_EID__c === "null") {
            username = this.lumenGlobysID + ":" + customer.Lumen_Account__c;
          } else if (customer.Lumen_Account__c !== "null" && customer.Lumen_Customer_EID__c !== "null") {
            username = customer.Lumen_Customer_EID__c + ":" + this.lumenGlobysID + ":" + customer.Lumen_Account__c;
          }
        }

        const registerUrl = environment.serverURL + environment.pgURI + "globys/user/register";
        let registerData: any = {
          userLogin: username,
          userState: 'adminFullAccess'
        };

        if (customer.Lumen_Account__c === 'null' && customer.Lumen_Customer_EID__c === 'null') {
          registerData.orgNumber = customer.EW_Account_Number__c;
        } else {
          registerData.orgNumber = customer.Lumen_Account__c !== 'null' ? customer.Lumen_Account__c : customer.EW_Account_Number__c;
        }
        let logTraceJSON: any = { 'eventSource': 'billAnalystRegisterUser', 'payload': registerData, 'userLogin': username, 'customerId': this.selectedCustomer };
        const headers = new HttpHeaders({
            'X-Log-Trace': JSON.stringify(logTraceJSON),
        });
        this.http.post(registerUrl, registerData, {headers}).subscribe(
          (response: any) => {
            if (response.length === 0) {
              this.handleError(content, "Unable to process your request, Please try again later.");
              return;
            }
            const firstName = JSON.parse(localStorage.getItem('idTokenClaims') || '{}').name || '';
            const lastName = JSON.parse(localStorage.getItem('idTokenClaims') || '{}').realm || '';
            const configureUrl = environment.serverURL + environment.pgURI + "globys/user/configure";
            const configureData = {
              "userLogin": username,
              "email": email,
              "emailLoadNotify": "on",
              "firstName": firstName,
              "lastName": lastName
            };
            let logTraceJSON: any = { 'eventSource': 'billAnalystConfigureUser', 'payload': configureData, 'userLogin': username, 'email': email };
            const headers = new HttpHeaders({
                'X-Log-Trace': JSON.stringify(logTraceJSON),
            });
            this.http.post(configureUrl, configureData, {headers}).subscribe(
              (configureRes: any) => {
                if (res.length === 0) {
                  this.handleError(content, "Unable to process your request, Please try again later.");
                  return;
                }
                const ssoUrl = environment.serverURL + environment.pgURI + "globys/sso-url";
                const ssoData = {
                  "userLogin": username,
                  "langCode": "eng",
                  "tokenExpirationSeconds": 3000,
                  "useToken": true
                };
                let logTraceJSON: any = { 'eventSource': 'billAnalystPostDataForSSOUrl', 'payload': ssoData, 'userLogin': username };
                const headers = new HttpHeaders({
                    'X-Log-Trace': JSON.stringify(logTraceJSON),
                });
                this.http.post(ssoUrl, ssoData, {headers}).subscribe(
                  (ssoResponse: any) => {
                    if (response.length === 0) {
                      this.handleError(content, "Unable to process your request, Please try again later.");
                      return;
                    }
                    const ssoUrl = ssoResponse.href;
                    this.isLoading = false;
                    this.openUrlInNewTab(ssoUrl);
                    this.isLoading = false;
                  },
                  (error: any) => {
                    this.handleError(content, this.errorMessage);
                  }
                );
              },
              (error: any) => {
                this.handleError(content, this.errorMessage);
              }
            );
          },
          (error: any) => {
            this.handleError(content, this.errorMessage);
          }
        );
      },
      (error: any) => {
        this.handleError(content, this.errorMessage);
      }
    );
  }

  private handleError(content: any, errorMessage: string) {
    this.isLoading = false;
    this.open(content);
    this.registrationMessage = errorMessage;
    console.error(errorMessage);
  }

  openUrlInNewTab(url: string) {
    const win = window.open(url, '_blank');
  }
}